<template>
  <div class="container mx-auto my-2">
    <div class="px-2">
<!--      <select class="form-select block w-full mt-1" v-model="selectedGender">-->
<!--        <option value="">选择性别</option>-->
<!--        <option>男</option>-->
<!--        <option>女</option>-->
<!--        <option>其他</option>-->
<!--      </select>-->

<!--      <select class="form-select block w-full mt-1" v-model="selectedRegion">-->
<!--        <option value="">选择地区</option>-->
<!--        <option>纽约</option>-->
<!--        <option>其它地区</option>-->
<!--      </select>-->

<!--      &lt;!&ndash; 语言选择 &ndash;&gt;-->
<!--      <select class="form-select block w-full mt-1" v-model="selectedLanguage">-->
<!--        <option value="">选择语言</option>-->
<!--        <option>中文</option>-->
<!--        <option>英文</option>-->
<!--      </select>-->

      <!-- 专科选择 -->

      
      <select class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" v-model="selectedMajor">
        <option value="" class="text-center" >显示所有科室</option>
        <option v-for="specialty in specialties" :value="specialty.zh" :key="specialty.zh" >{{ specialty.zh }}
          {{ specialty.en }}
        </option>
      </select>
    </div>
  </div>
</template>

<script setup>
const props = defineProps(['specialty'])
const emit = defineEmits(['update:specialty'])

const selectedGender = ref('')
const selectedRegion = ref('')
const selectedLanguage = ref('')

const selectedMajor = computed({
  get: () => props.specialty,
  set: (value) => emit('update:specialty', value),
})

/*Specialty 專科
Allergy & Immunology 敏感免疫科 (5)
Cardiothoracic Surgery 心胸外科 (1)
Cardiovascular Disease 心血管疾病科 (20)
Clinical Cardiac Electrophysiology 心電生理學科 (1)
Colon & Rectal Surgery 結腸及直腸科 (3)
Dentistry - Prosthodontics 口腔修復科 (1)
Dermatology 皮膚科 (22)
Dietetics - Medical Nutrition Therapy 醫學營養科 (4)
Endocrinology 內分泌科 (3)
Family Practice 家庭科 (53)
Gastroenterology 腸胃肝臟科 (35)
General Practice 普通內科 (1)
General Surgery 普通外科 (3)
Hematology 血液科 (2)
Infectious Disease 傳染病科 (2)
Internal Medicine 內科 (184)
Maternal Fetal Medicine 高險婦胎兒科 (1)
Medical Oncology 腫瘤科 (2)
Medical Oncology & Hematology 腫瘤血液科 (6)
Nephrology 腎臟科 (15)
Neurology 神經科 (15)
Neurosurgery 神經外科 (1)
Nurse Practitioner - Adult Health (2)
Nurse Practitioner - Family 執業護士-家庭 (4)
Nurse Practitioner - Pediatrics 執業護士 - 小兒科 (2)
Nurse Practitioner - Psychiatric-Mental Health 執業護士-心理科 (27)
Obstetrics & Gynecology 婦產科 (44)
Ophthalmology 眼科 (50)
Orthopedic Surgery 骨骼外科 (7)
Otolaryngology 耳鼻喉科 (15)
Pain Management 疼痛醫學科 (10)
Pediatric Neurology 兒童神經科 (3)
Pediatrics 小兒科 (68)
Physical Medicine & Rehabilitation 復健科 (25)
Plastic & Reconstructive Surgery 美容整形外科 (4)
Podiatry 腳科 (17)
Psychiatry 精神科 (16)
Psychiatry and Neurology 精神與神經科 (2)
Pulmonary Disease 胸肺科 (7)
Radiation Oncology 放射腫瘤科 (3)
Rheumatology 風濕病科 (5)
Speech Language Pathology 語言治療科 (1)
Urology 泌尿科 (10)
Vascular Neurology 血管神經科 (1)
Vascular Surgery 血管外科 (2)
Acupuncture 針灸科 (80)
Anesthesiology 麻醉科 (17)
Audiology 聽力科 (7)
Chiropractic Medicine 脊椎神經科 (3)
Dentistry - Endodontics 牙髓病科 (2)
Dentistry - General 牙科 (118)
Dentistry - Oral & Maxillofacial Surgery 口腔頜面外科 (7)
Dentistry - Pediatrics 兒童牙科 (12)
Marriage & Family Therapy 婚姻家庭科 (2)
Nuclear Medicine 核醫學科 (1)
Nurse Practitioner 執業護士 (23)
Occupational Therapy 職能治療科 (7)
Optometry 驗光科 (24)
Physical Therapy 物理治療科 (72)
Physician Assistant 助理醫師 (48)
Psychology 心理科 (2)
Psychotherapy 心理治療科 (73)
Radiology - Diagnostic 放射科 - 診斷 (60)*/
const specialties = [
  {"en": "Allergy & Immunology", "zh": "敏感免疫科"},
  {"en": "Cardiothoracic Surgery", "zh": "心胸外科"},
  {"en": "Cardiovascular Disease", "zh": "心血管疾病科"},
  {"en": "Clinical Cardiac Electrophysiology", "zh": "心电生理学科"},
  {"en": "Colon & Rectal Surgery", "zh": "结肠及直肠科"},
  {"en": "Dentistry - Prosthodontics", "zh": "口腔修复科"},
  {"en": "Dermatology", "zh": "皮肤科"},
  {"en": "Dietetics - Medical Nutrition Therapy", "zh": "医学营养科"},
  {"en": "Endocrinology", "zh": "内分泌科"},
  {"en": "Family Practice", "zh": "家庭科"},
  {"en": "Gastroenterology", "zh": "肠胃肝脏科"},
  {"en": "General Practice", "zh": "普通内科"},
  {"en": "General Surgery", "zh": "普通外科"},
  {"en": "Hematology", "zh": "血液科"},
  {"en": "Infectious Disease", "zh": "传染病科"},
  {"en": "Internal Medicine", "zh": "内科"},
  {"en": "Maternal Fetal Medicine", "zh": "高险妇胎儿科"},
  {"en": "Medical Oncology", "zh": "肿瘤科"},
  {"en": "Medical Oncology & Hematology", "zh": "肿瘤血液科"},
  {"en": "Nephrology", "zh": "肾脏科"},
  {"en": "Neurology", "zh": "神经科"},
  {"en": "Neurosurgery", "zh": "神经外科"},
  {"en": "Nurse Practitioner - Adult Health", "zh": "执业护士 - 成人健康"},
  {"en": "Nurse Practitioner - Family", "zh": "执业护士-家庭"},
  {"en": "Nurse Practitioner - Pediatrics", "zh": "执业护士 - 小儿科"},
  {"en": "Nurse Practitioner - Psychiatric-Mental Health", "zh": "执业护士 - 心理科"},
  {"en": "Obstetrics & Gynecology", "zh": "妇产科"},
  {"en": "Ophthalmology", "zh": "眼科"},
  {"en": "Orthopedic Surgery", "zh": "骨骼外科"},
  {"en": "Otolaryngology", "zh": "耳鼻喉科"},
  {"en": "Pain Management", "zh": "疼痛医学科"},
  {"en": "Pediatric Neurology", "zh": "儿童神经科"},
  {"en": "Pediatrics", "zh": "小儿科"},
  {"en": "Physical Medicine & Rehabilitation", "zh": "复健科"},
  {"en": "Plastic & Reconstructive Surgery", "zh": "美容整形外科"},
  {"en": "Podiatry", "zh": "脚科"},
  {"en": "Psychiatry", "zh": "精神科"},
  {"en": "Psychiatry and Neurology", "zh": "精神与神经科"},
  {"en": "Pulmonary Disease", "zh": "胸肺科"},
  {"en": "Radiation Oncology", "zh": "放射肿瘤科"},
  {"en": "Rheumatology", "zh": "风湿病科"},
  {"en": "Speech Language Pathology", "zh": "语言治疗科"},
  {"en": "Urology", "zh": "泌尿科"},
  {"en": "Vascular Neurology", "zh": "血管神经科"},
  {"en": "Vascular Surgery", "zh": "血管外科"},
  {"en": "Acupuncture", "zh": "针灸科"},
  {"en": "Anesthesiology", "zh": "麻醉科"},
  {"en": "Audiology", "zh": "听力科"},
  {"en": "Chiropractic Medicine", "zh": "脊椎神经科"},
  {"en": "Dentistry - Endodontics", "zh": "牙髓病科"},
  {"en": "Dentistry - General", "zh": "牙科"},
  {"en": "Dentistry - Oral & Maxillofacial Surgery", "zh": "口腔颌面外科"},
  {"en": "Dentistry - Pediatrics", "zh": "儿童牙科"},
  {"en": "Marriage & Family Therapy", "zh": "婚姻家庭科"},
  {"en": "Nuclear Medicine", "zh": "核医学科"},
  {"en": "Nurse Practitioner", "zh": "执业护士"},
  {"en": "Occupational Therapy", "zh": "职能治疗科"},
  {"en": "Optometry", "zh": "验光科"},
  {"en": "Physical Therapy", "zh": "物理治疗科"},
  {"en": "Physician Assistant", "zh": "助理医师"},
  {"en": "Psychology", "zh": "心理科"},
  {"en": "Psychotherapy", "zh": "心理治疗科"},
  {"en": "Radiology - Diagnostic", "zh": "放射科 - 诊断"}
]
</script>

<style>
</style>
